<template>
  <div class="toggle-group">
    <table>
      <tr>
        <td v-for="option in data.options" :class="{selected: data.props.defaultValue === option.value}">
          {{ option.label }}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'CHECKBOX',
  props: ['data'],
}
</script>



// WEBPACK FOOTER //
// TOGGLE_GROUP.vue?629abd66